import { CHECKOUT_COMPLETED } from '~/generated/AnalyticsTypes';
import useAnalytics from '~/react-hooks/use-analytics';
import { useEffect } from 'react';
import useSyncBilling from './use-sync-billing';
import { usePlandalfSdk } from '~/plandalf/use-plandalf-sdk';

export interface UsePlandalfCheckoutSuccessProps {
  onCheckoutSuccess?: () => void;
}

export default function usePlandalfCheckoutSuccess({
  onCheckoutSuccess,
}: UsePlandalfCheckoutSuccessProps) {
  const analytics = useAnalytics();
  const { syncBilling } = useSyncBilling();
  const sdk = usePlandalfSdk();

  useEffect(() => {
    if (typeof sdk?.on !== 'function') return;

    const checkoutSuccessHandler = async () => {
      onCheckoutSuccess?.();

      analytics.track(CHECKOUT_COMPLETED, {
        context: 'plandalf_checkout_completed',
      });

      await syncBilling();
    };

    sdk.on('checkout-success', checkoutSuccessHandler);

    return () => {
      sdk.removeListener?.('checkout-success', checkoutSuccessHandler);
    };
  }, [sdk, analytics, syncBilling, onCheckoutSuccess]);
}
